import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {PAP_SMEAR_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/pap-smear-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/pap-smear-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/pap-smear-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/pap-smear-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/pap-smear-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const PapSmearTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case PAP_SMEAR_TEST_KEYS.START:
        trackPageViewGA('/pap-smear-test/start', 'MDQ-Pap Smear Test - Start');
        return <Questionnaire1Screen />;
      case PAP_SMEAR_TEST_KEYS.PROFILE:
        trackPageViewGA('/pap-smear-test/profile', 'MDQ-Pap Smear Test - Profile');
        return <Questionnaire2Screen />;
      case PAP_SMEAR_TEST_KEYS.INVALID:
        trackPageViewGA('/pap-smear-test/invalid', 'MDQ-Pap Smear Test - Invalid');
        return <Questionnaire3Screen />;
      case PAP_SMEAR_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/pap-smear-test/appointment-preferences', 'MDQ-Pap Smear Test - Appointment Preferences');
        return <Questionnaire4Screen />;
      case PAP_SMEAR_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/pap-smear-test/your-test-package', 'MDQ-Pap Smear Test - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default PapSmearTest;
